import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/logo_wTVision_white.png'
import _imports_1 from '../assets/admin.png'
import _imports_2 from '../assets/login.png'
import _imports_3 from '../assets/register.png'
import _imports_4 from '../assets/logout.png'


const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "BottomContainer" }
const _hoisted_3 = { class: "user-area" }
const _hoisted_4 = {
  key: 0,
  class: "login"
}
const _hoisted_5 = {
  key: 3,
  class: "or-style"
}
const _hoisted_6 = {
  key: 6,
  style: {"text-wrap":"nowrap","color":"#969696","font-family":"sans-serif","font-size":"25px","margin-left":"30px","margin-top":"5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HexagonButton = _resolveComponent("HexagonButton")!
  const _component_NewProject = _resolveComponent("NewProject")!
  const _component_OpenProject = _resolveComponent("OpenProject")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"TriangleTop\" data-v-e705b812><div class=\"TriangleVerticalTop\" data-v-e705b812><div class=\"logo-container\" data-v-e705b812><img class=\"logo\" src=\"" + _imports_0 + "\" alt=\"Logo\" data-v-e705b812></div></div><div class=\"TriangleVerticalLine\" data-v-e705b812></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                id: "email",
                name: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                placeholder: "Email",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.email]
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "password",
                name: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                placeholder: "Password",
                required: "",
                type: "password"
              }, null, 512), [
                [_vModelText, _ctx.password]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _imports_1,
              alt: "",
              title: "Administrator Dashboard",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navToAdmin && _ctx.navToAdmin(...args)))
            }))
          : _createCommentVNode("", true),
        (!_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("img", {
              key: 2,
              src: _imports_2,
              alt: "",
              title: "Login",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
            }))
          : _createCommentVNode("", true),
        (!_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("label", _hoisted_5, "OR"))
          : _createCommentVNode("", true),
        (!_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("img", {
              key: 4,
              src: _imports_3,
              alt: "",
              title: "Create new user",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.navToRegister && _ctx.navToRegister(...args)))
            }))
          : _createCommentVNode("", true),
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("img", {
              key: 5,
              src: _imports_4,
              alt: "",
              title: "Logout",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.logoutUser && _ctx.logoutUser(...args)))
            }))
          : _createCommentVNode("", true),
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("label", _hoisted_6, "Logged: " + _toDisplayString(_ctx.username), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_HexagonButton, {
        id: "new",
        class: _normalizeClass({ 'disable': !_ctx.isAuthenticated || !_ctx.isAdmin, 'unglow-and-unslide-new': _ctx.isNewCancel, 'fade-in':_ctx.isOpenCancel, 'glow-and-slide-new': _ctx.clickedButton === 'NEW', 'fade-out': _ctx.clickedButton === 'OPEN' }),
        label: "NEW",
        backgroundcolor: "#151515",
        textcolor: _ctx.isAuthenticated ? 'white' : 'gray',
        onClick: _ctx.onNewClick
      }, null, 8, ["class", "textcolor", "onClick"]),
      _createVNode(_component_HexagonButton, {
        id: "open",
        class: _normalizeClass({ 'disable': !_ctx.isAuthenticated, 'unglow-and-unslide-open': _ctx.isOpenCancel, 'fade-in':_ctx.isNewCancel, 'glow-and-slide-open':_ctx.clickedButton === 'OPEN', 'fade-out': _ctx.clickedButton === 'NEW'}),
        style: 'margin-left:25px',
        label: "OPEN",
        backgroundcolor: "#151515",
        textcolor: _ctx.isAuthenticated ? 'white' : 'gray',
        onClick: _ctx.onOpenClick
      }, null, 8, ["class", "textcolor", "onClick"]),
      (_ctx.showNewProject)
        ? (_openBlock(), _createBlock(_component_NewProject, {
            key: 0,
            class: _normalizeClass({'fade-in-new-project':_ctx.isNew, 'fade-out-new-project':_ctx.isNewCancel}),
            onCancelNewProject: _ctx.onNewCancel
          }, null, 8, ["class", "onCancelNewProject"]))
        : _createCommentVNode("", true),
      (_ctx.showOpenProject)
        ? (_openBlock(), _createBlock(_component_OpenProject, {
            key: 1,
            class: _normalizeClass({'fade-in-open-project':_ctx.isOpen, 'fade-out-open-project':_ctx.isOpenCancel}),
            onCancelOpenProject: _ctx.onOpenCancel
          }, null, 8, ["class", "onCancelOpenProject"]))
        : _createCommentVNode("", true)
    ])
  ]))
}